<p-accordion [value]="alwaysExpanded() || isExpanded() ? 1 : 0" transitionOptions="200ms ease-in-out">
  <p-accordion-panel tabStyleClass="mb-0" [value]="1" [disabled]="disabled()">
    <p-accordion-header [style]="titleCss" [class.pointer-events-none]="alwaysExpanded()" (click)="onHeaderClicked()">
      @if (hasLeftCb()) {
        <p-checkbox
          class="mr-3"
          [binary]="true"
          [(ngModel)]="checked"
          [disabled]="disabled() || leftCbDisabled()"
          [ariaLabelledBy]="uniqueId"
          (ngModelChange)="setExpansion($event)"
          (click)="$event.stopPropagation()"
        />
      }

      @if (titleIconClass()) {
        <i class="title-icon {{ titleIconClass() }}" [class.text-center]="hasLeftCb()" [class.opacity-40]="disabled()"></i>
      }

      @if (title()) {
        <h3 [style.fontSize]="titleFontSize() ? titleFontSize() + 'px' : 'inherit'" [style.fontFamily]="titleFont()" class="m-0 align-self-center" [class.opacity-40]="disabled()">
          {{ disabled() && disabledTitle() ? disabledTitle() : title() }}
        </h3>
      } @else {
        <ng-content select="[header]" />
      }

      <ng-template #toggleicon>
        @if (!alwaysExpanded()) {
          <i class="arrow-icon fas fa-chevron-down flex-order-2 ml-auto" [class.hidden]="disabled()" [class.rotate-180]="isExpanded()"></i>
        }
      </ng-template>
    </p-accordion-header>

    <p-accordion-content
      class="border-none"
      [style]="{ backgroundColor: contentBackgroundColor() ? contentBackgroundColor() : '#ffffff' }"
      [style.padding-top]="alwaysExpanded() || isExpanded() ? '1.125rem' : '0'"
      (keydown)="$event.stopPropagation()"
    >
      <ng-content select="[content]" />
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
